const getRootLocationUrl = (origin) => {
    const publicUrl = process.env.PUBLIC_URL;
    return typeof publicUrl === 'string' && publicUrl.length > 0 ? publicUrl : origin;
}

export const isValidUrl = string => {
    const pattern = /^(https?|\/)/;

    return pattern.test(string);
}

export const calculateValidPdfUrl = ({ string, origin }) => {
    if (typeof string === 'undefined') return undefined;
    if (isValidUrl(string)) return `${string}#toolbar=0&view=Fit&pagemode=thumbs`;

    const url = `${getRootLocationUrl(origin)}/${string}#toolbar=0&view=Fit&pagemode=thumbs`;

    return url;
}

export const extractDefaultPdfFromOptions = ({ options, origin }) => {
    let defaultPDF;

    for (const option of options || []) {
        if (option?.attachments?.length > 0) {
            const primaryPdfFileString = option.attachments[0]?.url;
            defaultPDF = calculateValidPdfUrl({ string: primaryPdfFileString, origin });
            break; // exit if found
        }
    }

    return defaultPDF;
}

export const extractPdfFromSelectedOption = ({ selectedOption, origin }) => {

    if (selectedOption?.attachments?.length > 0) {
        if (selectedOption?.attachments?.length === 1) {
            const pdfFileString = selectedOption?.attachments?.[0]?.url;
            return calculateValidPdfUrl({ string: pdfFileString, origin });
        }
        else {
            const pdfFileString = selectedOption?.attachments?.[1]?.url;
            return calculateValidPdfUrl({ string: pdfFileString, origin });
        }
    }

    return undefined;
}

/**
 * Retrieves the dimensions of the browser window, optionally subtracting specified values.
 *
 * @param {Object} [options={}] - Optional parameters to adjust the window dimensions.
 * @param {number} [options.minusHeight=0] - A value to subtract from the window's height.
 * @param {number} [options.minusWidth=0] - A value to subtract from the window's width.
 * @returns {Object|null} - An object containing the adjusted width and height of the window, 
 *                          or `null` if the window object is not available (e.g., server-side rendering).
 * @returns {number} return.width - The adjusted width of the window in pixels.
 * @returns {number} return.height - The adjusted height of the window in pixels.
 *
 * @example
 * // Basic usage:
 * const dimensions = getWindowDimensions();
 * console.log(dimensions.width, dimensions.height);
 *
 * @example
 * // With optional subtracted values:
 * const dimensions = getWindowDimensions({ minusHeight: 50, minusWidth: 100 });
 * console.log(dimensions.width, dimensions.height);
 */
export const getReducedWindowDimensions = ({ minusHeight = 0, minusWidth = 0, id, url } = {}) => {
    if (typeof window !== 'undefined') {
        let { innerWidth: width, innerHeight: height } = window;
        if (id && document.getElementById(id).offsetWidth && document.getElementById(id).offsetHeight) {
            width = document.getElementById(id).offsetWidth;
            height = Math.min(600, document.getElementById(id).offsetHeight);
            return {
                width: width,
                height:height,
                widthPx: `${width}px`,
                heightPX: `${height}px`,
            };
        }
        const reducedWidth = Math.max(0, Math.floor(width) - minusWidth);
        const reducedHeight =  Math.max(600, Math.floor(height) - minusHeight);
        return {
            width: reducedWidth,
            height:reducedHeight,
            widthPx: `${reducedWidth}px`,
            heightPX: `${reducedHeight}px`,
        };
    }
    return null; // or return an empty object {}
};